// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3bGGo","approved":"Status_approved__qdFE3","rejected":"Status_rejected__1_3Ul","expired":"Status_expired__1wzkR","label":"Status_label__3B3cM"};